// @flow
import { connect } from 'react-redux';
import type { State } from '../../../../../types';
import { debugConfigSelector } from '../../../../../selectors/configSelectors';
import { carListSelector } from '../../../../../selectors/carSelectors';
import Cars from '../Cars';
import type { Props } from '../Cars';

const mapStateToProps = (state: State) => {
    const debugConfig = debugConfigSelector(state);

    return {
        cars: carListSelector(state),
        showBothSources: debugConfig.showBothSources
    };
};

export default connect<Props, *, _, _, _, _>(mapStateToProps)(Cars);